<div class="email-threads">
    <div class="content">
        <div class="button-group">
            <li class="dropdown" dropdown>
                <button dropdownToggle type="button" class="secondary-button btn-padding"
                    data-automation-id="email-threads-dropdown-button" [disabled]="emailThreadsActionsDisabled">
                    <i class="fa fa-chain color-blue-01"></i>
                    <span>Email Threads</span>
                    <i class="fa fa-caret-down"></i>
                </button>
                <ul *dropdownMenu class="dropdown-menu">
                    <li (click)="threadEmails()" class="menu-item"
                        data-automation-id="email-threads-update-all-threads-button"
                        [ngClass]="{'disabled' : !updateThreadsButton }">
                        <label>
                            <i class="fa fa-refresh menu-item-icon color-blue-01"></i>
                            <span>Update All Threads</span>
                        </label>
                    </li>
                    <li (click)="unthreadAllEmails()" class="menu-item"
                        data-automation-id="email-threads-unthread-all-emails-button"
                        [ngClass]="{'disabled' : !unthreadEmailsButton }">
                        <label>
                            <i class="fa fa-chain-broken menu-item-icon color-blue-01"></i>Unthread All Emails
                        </label>
                    </li>
                </ul>
            </li>
        </div>
        <res-document-list #threadGrid [responseCallback]="responseCallback"
            [gridPagerCustomCallback]="gridPagerCustomCallback"></res-document-list>

        <div class="generate-threads">
            <div class="create-email-threads-container" [hidden]="!generateButtonVisible">
                <div class="create-cluster-list-container-button">
                    <button type="button" [attr.data-automation-id]="automationId + '-generate-button'"
                        class="primary-button" (click)="threadEmails()">Thread All Emails</button>
                </div>
            </div>
        </div>
    </div>

</div>